import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import ptBR from "./locales/pt-BR.json";
import enUS from "./locales/en-US.json";
import { PRODUCT_NAME } from "./brand";

export function initI18n() {
  void i18n.use(initReactI18next).init({
    resources: { "pt-BR": { translation: ptBR }, "en-US": { translation: enUS } },
    lng: "pt-BR",
    fallbackLng: "en-US",
    // `{{product}}` in any string resolves to the brand constant (ADR 380).
    interpolation: { escapeValue: false, defaultVariables: { product: PRODUCT_NAME } },
  });
}
